export default function cpfMask(value: string): string {
    let newValue = value

    if (!newValue) return ''

    if (newValue.length > 14) {
        return newValue.slice(0, 14)
    }

    newValue = newValue.replace(/\D/g, '')
    newValue = newValue.replace(/^(\d{3})(\d)/, '$1.$2')

    if (newValue.length > 5) {
        newValue = newValue.replace(/^(.{7})(\d)/, '$1.$2')
    }

    if (newValue.length > 11) {
        newValue = newValue.replace(/^(.{11})(\d)/, '$1-$2')
    }

    return newValue
}
